// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2642) return "static/chunks/2642.c2ba6f727d812e90.js";
	if (chunkId === 899) return "static/chunks/899.ff1302dbf4f758f6.js";
	if (chunkId === 1396) return "static/chunks/1396.b7496b8bb64c600e.js";
	if (chunkId === 9779) return "static/chunks/9779.2f15c98ad6f66aad.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"72":"0364d38a9e587134","1071":"0fee91448e1395c7","2726":"7ae6c448260acec8","3860":"227c1b9f923eebe9","4220":"1f02c05a3e2c86a9","4305":"155c3705d6ea64e0","4931":"527f992aa05495da","6671":"292b659bbaf36223","6999":"65d8b7812bd22568","9373":"5a7b04f2b67bb9ac"}[chunkId] + ".js";
};